module.exports = __webpack_public_path__ + "static/media/mobile2.47643f72.png";